import { findSuperior } from '@/common/functions/findSuperior';

const getTeamQueueProducts = ({ users, queues, products, leaderId }) => {
	if (!leaderId) {
		return [];
	}

	const memberIds = new Set([
		leaderId,
		...(users || [])
			.filter((user) => findSuperior(user._id, users)?._id === leaderId)
			.map((user) => user._id),
	]);

	const productIds = new Set(
		(queues || [])
			.filter((queue) =>
				queue.consultants?.some((consultantId) => memberIds.has(consultantId)),
			)
			.map((queue) => queue.product),
	);

	return (products || []).filter(
		(product) => productIds.has(product._id) && product.is_active !== false,
	);
};

export const getTeamLeaderSuperProductOptions = ({
	users,
	queues,
	products,
	superProducts,
	leaderId,
}) => {
	const superProductIds = new Set(
		getTeamQueueProducts({ users, queues, products, leaderId }).map(
			(product) => product.super_product,
		),
	);

	return (superProducts || [])
		.filter((superProduct) => superProductIds.has(superProduct._id))
		.map((superProduct) => ({
			label: superProduct.name,
			value: superProduct._id,
		}))
		.sort((left, right) => left.label.localeCompare(right.label));
};

export const getQueuedProductIdsForSuperProduct = ({
	superProductId,
	users,
	queues,
	products,
	leaderId,
}) => {
	if (!superProductId) {
		return [];
	}

	return getTeamQueueProducts({ users, queues, products, leaderId })
		.filter((product) => product.super_product === superProductId)
		.map((product) => product._id);
};
